import { createAction } from "redux-starter-kit";
import { SWITCH_ZOOM, NO_ZOOM } from "../actionTypes";

export const switchZoomAction = createAction(SWITCH_ZOOM);
export const noZoomAction = createAction(NO_ZOOM);
